import { css, Theme } from '@emotion/react'
import { Container } from '@mui/material'

import { WorkQuery } from '../../../generated/graphql.api'

import WorksHero from '~/components/organisms/WorksHero'
import WorksBody from '~/components/organisms/WorksBody'
import { DetailsOutlined } from '@mui/icons-material'

type Props = {
  data: WorkQuery
}

const WorksPageTemplate: React.FC<Props> = ({ data }) => {
  const detail = data.page.edges[0].node

  return (
    <main>
      <WorksHero
        client={detail.client}
        title={detail.title}
        category={detail.category}
        src1={detail.listimage.url}
        src2={detail.coverImage.url}
      />
      <WorksBody
        head={detail.head}
        description={detail.description}
        url={detail.url}
        image1={detail.image1.url}
        image2={detail.image2.url}
        description2={detail.description2}
      />
    </main>
  )
}

export default WorksPageTemplate
